export default __webpack_public_path__ + "static/media/speakup_yellow.7dc1249d.svg";